var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeatport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#0D0D0D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 41.0426C51 48.7589 44.7968 55 36.8704 55C29.0589 55 22.8557 48.9291 22.8557 41.0426C22.8557 37.3546 24.2916 34.0638 26.5317 31.6241L16.9971 41.0426L12 36.0496L22.7408 25.5532C24.1767 24.1348 24.9234 22.2624 24.9234 20.1631V7H31.9882V20.2199C31.9882 24.2482 30.5523 27.7092 27.6804 30.4894L27.3932 30.7731C29.863 28.5035 33.2518 27.1418 36.8704 27.1418C44.9116 27.1418 51 33.4397 51 41.0426ZM44.6244 41.0426C44.6244 36.9007 41.1782 33.5532 36.9278 33.5532C32.62 33.5532 29.2312 37.0709 29.2312 41.0426C29.2312 45.1277 32.62 48.5887 36.8704 48.5887C41.2931 48.5887 44.6244 45.0142 44.6244 41.0426Z",
    fill: "#01FF95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeatport);
export default __webpack_public_path__ + "static/media/beatport.47fd7be7fc4145db5fd3989387db940b.svg";
export { ForwardRef as ReactComponent };